interface Timed {
  readonly start_ms: number;
}

export type TranscriptEntry<T extends Timed, G extends Timed> =
  | { readonly kind: "turn"; readonly turn: T; readonly at: number }
  | { readonly kind: "gap"; readonly gap: G; readonly at: number };

export function transcriptEntries<T extends Timed, G extends Timed>(
  turns: readonly T[],
  gaps: readonly G[],
): TranscriptEntry<T, G>[] {
  return [
    ...turns.map((turn) => ({ kind: "turn" as const, turn, at: turn.start_ms })),
    ...gaps.map((gap) => ({ kind: "gap" as const, gap, at: gap.start_ms })),
  ].sort((a, b) => a.at - b.at);
}

export function entryIndexOfTurn<T extends Timed & { readonly idx: number }, G extends Timed>(
  entries: readonly TranscriptEntry<T, G>[],
  idx: number | null,
): number {
  if (idx === null) return -1;
  return entries.findIndex((e) => e.kind === "turn" && e.turn.idx === idx);
}

export function withMounted(range: readonly number[], keep: readonly number[]): number[] {
  const extra = keep.filter((i, n) => i >= 0 && !range.includes(i) && keep.indexOf(i) === n);
  return extra.length === 0 ? [...range] : [...range, ...extra].sort((a, b) => a - b);
}
